export enum AppManagerRoles {
  RCAPP_MANAGER = 'rcapp.manager',
  HVLAPP_MANAGER = 'hvlapp.manager',
  EOS_MANAGER = 'eos.manager',
  ASCIW_MANAGER = 'asicw.manager',
}

export enum AppOperatorRoles {
  RCAPP_OPERATOR = 'rcapp.operator',
  HVLAPP_OPERATOR = 'hvlapp.operator',
  ASCIW_OPERATOR = 'asicw.operator',
}

export enum AppViewerRoles {
  ASICW_VIEWER = 'asicw.viewer',
}

export const AdminRole = 'admin'
